import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import Datatable from "components/Core/DataTable";
import {
	Card,
	CardHeader,
	CardBody,
	CardTitle,
	Row,
	Form,
	Col,
	ModalHeader,
	ModalBody,
	Button,
	ModalFooter,
	Modal
} from "reactstrap";
import Notify from "../lib/Utils/Alert";
import {MotionButton} from "../components/Core/MotionStrap";
import NotificationAlert from "react-notification-alert";
import CardType from "../lib/Core/Backend/Controllers/CardType";
import Utils from "../lib/Utils/Utils";
import FormValidator from "../lib/Utils/FormValidator";
import ModalHistorySKU from "components/PurchaseOrder/ModalHistorySKU";
import $ from "jquery"
import useBrands from "hooks/useBrands";
import useCatalogs from "hooks/useCatalogs";
import Spinner from 'react-bootstrap/Spinner';
import ConfirmationAlertTwo from "components/ConfirmationAlert/ConfirmationAlertTwo";
import EditCardTypeModal from "components/CardTypeView/Modal/EditCardType/EditCardTypeModal";
import * as modalCSVcss from "../components/Supplier/css/modalUploadCSV.module.css";
import { ReactComponent as UploadIcon } from "../assets/img/upload.svg";
import { BsInfoCircle } from "react-icons/bs";
import okIMG from "../assets/img/ok.png";
import Papa from 'papaparse';
const mapKeys = {
	amount: 'amount',
	brandId: 'brand',
	maxAmount: 'maxAmount',
	productName: 'name',
	currency: 'currency',
	imageUuid:"imageFile"
}

function CardTypeView(props)
{
	const {token} = props;
	const cardTypeCtl = useMemo(() => new CardType(token),[token]);
	const [modal, setModal] = useState(false);
	const [confirmModal, setConfirmModal] = useState(false);

	const [upload, setUpload] = useState(false);
	const [fileCsv, setFileCsv] = useState(null);
	const [activeOp, setActiveOp] = useState("");
	const [activeOpText, setActiveOpText] = useState("");
	const [operativeRow, setOperativeRow] = useState({});
	const [modalHistory, setModalHistory] = useState(false);
	const [showAlertMessage, setShowAlertMessage] = useState(false);
	const [warningModal,setWarningModal] = useState(false);
	const [reload, setReload] = useState(false);
	const [loading, setLoading] = useState(false)
	const [currencyId,setCurrencyId] = useState("");
	const [currencyName,setCurrencyName] = useState("")
	const [cardImageInput,setCardImageInput] = useState()
	const toggleModalHistory = () => setModalHistory(!modalHistory);
	const stayModal = () => setShowAlertMessage(false)
	const isMounted = useRef(null);
	const toggleWarning = () => setWarningModal(!warningModal)
    const [addNewcardLoading, setAddNewcardLoading] = useState(false);
	const [cardSave,setCardSave] = useState(false);
	const [showTooltip, setShowTooltip] = useState(false);

	const form = useRef();
	let table = null;
	const setTable = (ref) => table = ref;
	const alert = useRef();
	const cardImage = useRef();
	const maxAmtControl = useRef();

	const brands = useBrands();
	const {currencies} = useCatalogs();

	const header = [
		{
			title: 'Image', data: 'imageUuid', sortable: true, searchable: false, render: (data, type, row) =>
			{
				if (!data)
					return `<div class="ncentiva-gift-card-block" style="background-color: #cdcdcd;"></div>`;
				return `<div class="ncentiva-gift-card-block" style="background-image: url('${cardTypeCtl.image(data, row.edited)}');"></div>`;
			},
			width: "10%"
		},
		{
			title: 'Product Name', data: 'productName', sortable: true, searchable: true, render: $.fn.dataTable.render.text(), renderForSelect: (data) => ({label: data, value: data})
		},
		{
			title: 'Brand', data: 'brandName', sortable: true, searchable: true,
		},
		{
			title: 'SKU', data: 'sku', sortable: true, searchable: true,
		},
		{
			title: 'Currency', data: 'currency', sortable: true, searchable: true, render: $.fn.dataTable.render.text(), renderForSelect: (data) => ({label: data, value: data})
		},
		{
			title: 'Type', data: 'amount', sortable: true,  render: data =>
			{
				return !!data ? "Fixed" : "Variable"
			}
		},
		{
			title: 'Amount', data: 'amount', sortable: true, searchable: false, render: (data, _type, row) =>
			{
				if (!!data)
					return data.toFixed(2);

				return `${row.minAmount.toFixed(2)} - ${row.maxAmount.toFixed(2)}`;
			}
		}
	];

	const fillCatalog = () =>
	{
		if (form.current)
		{
			form.current.reset();

			Utils.FillDropdown(form.current.brand, brands.sort((a, b) => a.name.localeCompare(b.name)));
			Utils.FillDropdown(form.current.currency, currencies.sort((a, b) => a.name.localeCompare(b.name)), null, null, null, (cat) => cat.code);

			if (maxAmtControl.current)
				maxAmtControl.current.style.display = "none";

			form.current.type.checked = true;

			if (activeOp === "Edit" && !!operativeRow)
			{
				const rowData = operativeRow;
				const isFixed = !!rowData.amount
				form.current.cardTypeId.value = rowData.id;
				form.current.name.value = rowData.productName;
				form.current.currency.value = rowData.currency;
				form.current.brand.value = rowData.brandId;
				form.current.type.checked = isFixed;
				form.current.amount.value = isFixed ? rowData.amount : rowData.minAmount;
				maxAmtControl.current.style.display = isFixed ? "none" : "block";
				form.current.maxAmount.value = rowData.maxAmount;
				form.current.imageFile.value = rowData.imageUuid;
				// cardImage.current.style.backgroundImage = `url('${cardTypeCtl.image(rowData.imageUuid)}')`;
			}
		}
	}

	const toggle = () => setModal(!modal);
	const toggleConfirm = () => setConfirmModal(!confirmModal);

	function prepareToAdd()
	{
		toggle();
		setActiveOp("Add New");
		setActiveOpText("Please provide the information for the new gift card type.");
	}

	function prepareToEdit(row)
	{
		toggle();
		setActiveOp("Edit");
		setActiveOpText("Edit the required data for this gift card type");
		setOperativeRow(row.data())
	}

	function addCardType(){
		setTimeout(()=>{
			setAddNewcardLoading(false)
		}, 1500)
	}

	const saveCardTypeLoading = () =>{
		setTimeout(() => {
			setCardSave(false);
		}, 1500);
	}

	function finishOperation()
	{
		setAddNewcardLoading(true)
		const fv = new FormValidator(form.current, (type, message) => Notify(alert, type, message),
			[
				{label: "Brand", property: "brandId", input: "brand", required: true, noVal: "-1"},
				{label: "Product Name", property: "productName", input: "name", required: true},
				{label: "Currency", property: "currency", required: true},
				{
					label: "Face Value", property: "amount", required: true,
					ignoreCondition: {input: "type", type: "check", value: true},
					conditions: [
						{op: "gt", value: "0"}
					]
				},
				{
					label: "Min. Amount", property: "minAmount", input: "amount", required: true,
					ignoreCondition: {input: "type", type: "check", value: false},
					conditions: [
						{op: "gt", value: "0"}
					]
				},
				{
					label: "Max. Amount", property: "maxAmount", required: true,
					ignoreCondition: {input: "type", type: "check", value: false},
					conditions: [
						{op: "gt", input: "amount", label: "Min. Amount"},
						{op: "gt", value: "0"}
					]
				},
				{label: "Card Image", property: "imageUuid",input:"imageFile", required: false}
			]
		);

		if (!fv.isFormValid()){
			addCardType()
			return;
		}

		const cardTypeInfo = fv.getDTO();
		let giftcard = {
			imageUuid:cardImageInput,
			currency:currencyName,
			currencyId:currencyId,
		}
		Object.assign(cardTypeInfo, giftcard)
		const isFixed = form.current.type.checked;
		cardTypeInfo.amount = isFixed ? cardTypeInfo.amount : "0";
		cardTypeInfo.minAmount = !isFixed ? cardTypeInfo.minAmount : "0";
		cardTypeInfo.maxAmount = !isFixed ? cardTypeInfo.maxAmount : "0";

		switch (activeOp)
		{
			case "Add New":
				cardTypeCtl.add(cardTypeInfo, data =>
				{
					if(data?.status === 403){
                     toggleWarning();
					 addCardType()
					 toggle();
					 return;
					}
					if (data.errorMessage || data.error)
					{
						Notify(alert, "danger", data.errorMessage ?? data.error);
						addCardType()
					} else
					{
						Notify(alert,"success","Add card type  successfully");
						setReload(prev => !prev)
						addCardType()
						toggle();
					}
					// toggle();
				});
				break;
			case "Edit":
				cardTypeInfo.id = form.current.cardTypeId.value;
				cardTypeCtl.update(cardTypeInfo, data =>
				{
					if(data?.status === 403){
						toggleWarning();
						addCardType()
						toggle();
						return;
					   }
					if (data.errorMessage || data.error)
					{
						Notify(alert, "danger", data.errorMessage ?? data.error);
						addCardType()
					} else
					{
						Notify(alert,"success","Edit card type successfully");
						addCardType()
						// if (form.current.imageFile.files[0])
						// {
						// 	cardTypeCtl.updateImage(data.imageUuid, form.current.imageFile.files[0], idata =>
						// 	{
						// 		if (idata.errorMessage || idata.error)
						// 		{
						// 			Notify(alert, "danger", idata.errorMessage ?? idata.error);
						// 		} else
						// 		{
						// 			idata.edited = true;
						// 			setReload(prev => !prev)
						// 			toggle();
						// 		}
						// 	});
						// } else
						// {
						// 	setReload(prev => !prev)
						// 	toggle();
						// }
						toggle();
					}
				});
				break;
			default:
		}
	}

	function remove(row)
	{
		setOperativeRow(row.data());
		toggleConfirm();
	}

	function confirmRemoval()
	{
		const row = operativeRow;
		cardTypeCtl.remove(row?.id, data =>
		{
			if(data?.status === 403){
				toggleWarning();
				toggleConfirm();
				return;
			   }
			if (!data || data.error !== null)
			{
				if (data.status === 500)
					Notify(alert, "danger", "You cannot remove this Card Type.");
				else
					Notify(alert, "danger", data?.errorMessage ?? data?.error);
			} else
			{
				Notify(alert, "success", 'Card type deleted successfully');
				table.dataTable.row(row).remove().draw();
				setOperativeRow(null);

			}
			toggleConfirm();
		});
	}

	const setCardTypes = useCallback((data) =>
	{

		if (table && data && data.length > 0)
		{
			const rows = [];
			data.forEach((item) =>
			{
				item.edited = false;
				rows.push(item);
			});
			table.dataTable.clear().rows.add(
				rows.map(card => ({...card, brandName: brands.find(brand => brand.id === card.brandId)?.name ?? 'Not Available'}))	
			).draw();
		}
	},[table])

	function onImageChange(e)
	{
		if (form.current.imageFile.files[0]){
			if(e.target.files[0].size > 5242880){
				Notify(alert, 'danger', 'File size exceeds 5mB')
				e.target.value = null
				cardImage.current.style.backgroundImage = `none`;
				return
			}
			cardImage.current.style.backgroundImage = `url('${URL.createObjectURL(form.current.imageFile.files[0])}')`;
		} else
			cardImage.current.style.backgroundImage = `none`;
	}

	const modelChange = (initial, endModel) => {
		let changed = false
		Object.entries(initial).forEach(([key, value]) => {
			if (key === 'amount') {
				const isFixed = !!value
				if ((isFixed && value !== endModel[mapKeys[key]].value) || (!isFixed && initial.minAmount !== endModel[mapKeys[key]].value)) {
					changed = true
					return
				}
			} else if (endModel[mapKeys[key]] && value !== endModel[mapKeys[key]].value) {
				changed = true
				return
			}
		})
		return changed
	}

	const leaveAllModal = () => {
		setShowAlertMessage(false)
		setModal(false)
	}

	const handleCancelModal = () => {
		if (activeOp === 'Add New') {
			let hasChanges = false
			form.current.forEach(el => {
				if (!!el.value && el.value !== '-1') {
					hasChanges = true
				}
			})

			if (hasChanges) {
				setShowAlertMessage(true)
			} else {
				setModal(false)
			}

		} else {
			const formHasChanges = modelChange(operativeRow, form.current)
			if (formHasChanges){
				setShowAlertMessage(true)
			} else {
				setModal(!modal)
			}
		}
	} 

	useEffect(() =>
	{
		setTable.current = $('#example').DataTable();
		isMounted.current = true;
		cardTypeCtl.all(setCardTypes);
		return () =>
			{
			isMounted.current = false
			if (setTable.current) {
				setTable.current.destroy();
			  }
			};
			
		// cardTypeCtl.all(setCardTypes);
	},[setCardTypes, reload, cardTypeCtl]);


	let csv;
	const [selectedFile, setSelectedFile] = useState(null);
	const fileInputRef = useRef(null);
	const handleFileChange = (event) => {
		setSelectedFile(event.target.files[0]);
		setFileCsv(event.target.files[0]);
	  };
	  const toggleUpload = () => {
		setUpload(!upload);
		setFileCsv(null)
		setSelectedFile(null)

	}
	
	  const downloadFile = (data) => {
		let brandsData = data?.map((card) => (
			{
				brandId: card?.brandId,
				productName: card?.productName,
				currencyId: card?.currencyId,
				fixedValue : card?.fixedValue,
				amount: card.amount,
				maxAmount : card?.maxAmount,
				minAmount: card?.minAmount,
				// imageUuid: card?.imageUuid
			}
		)
	).sort(function (a, b)
	{
		var textA = a.productName.toUpperCase();
		var textB = b.productName.toUpperCase();
		return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
	});
	csv = Papa.unparse(brandsData);
	const element = document.createElement("a");
	const file = new Blob([csv], {type: 'text/plain'});
	element.href = URL.createObjectURL(file);
	element.download = "GiftCardTypes.csv";
	document.body.appendChild(element); // Required for this to work in FireFox
	element.click();
	  };
	
	  const downloadBrandLimit = async () => {
		await cardTypeCtl.downloadCardType((res) => {
		  if (res && !res.error) {
			downloadFile(res);
		  }
		});
		Notify(alert, "success", "File Succesfully Download");
	  };


	const handleFileUpload = async (event) => {
		setCardSave(true)
		event.preventDefault();
		const formData = new FormData();
		formData.append("file", selectedFile);
		if (selectedFile === null) {
			Notify(alert, "danger", "please upload a file");
			// setIsProcessing(false);
			saveCardTypeLoading()
			return false;
		  }
		const datas = await cardTypeCtl.uploadCardType(formData, (res) => {
			if(res?.status === 403){
				toggleWarning();
				toggleUpload();
				saveCardTypeLoading();
				return;
			   }
		//   setIsProcessing(true);
	       if (res === undefined) {
			saveCardTypeLoading()
			Notify(alert, "danger", "please upload a file");
			// setIsProcessing(false);
			return false;
		  } else if (res?.errorMessage) {
			saveCardTypeLoading()
			Notify(alert, "danger", res.errorMessage);
			// setIsProcessing(false);
			return false;
		  } else if (!res?.errorMessage) {
			saveCardTypeLoading()
			toggleUpload();
			Notify(alert, "success", res.true);
			setLoading(true)
			
		  }
		  
		});
	  };

	  useEffect(() => {
		
			if(loading == true){
				cardTypeCtl.all((data)=>{
					const rows = [];
					if(table && data){
					data.forEach((item) =>
					{
						item.edited = false;
						rows.push(item);
					});
					table.dataTable.rows.add(rows.map(card => ({...card, brandName: brands.find(brand => brand.id === card.brandId)?.name ?? 'Not Available'}))).draw();
	
					}
				});
					setTimeout(()=>{
						setLoading(false)

					},2000);
			
			
				}
		
	  }, [loading]);

	return (<>
	
		<NotificationAlert ref={alert}/>
		<ConfirmationAlertTwo stayModal={stayModal} openModal={showAlertMessage} leaveModal={leaveAllModal} />
		<EditCardTypeModal
			isOpen={modal}
			toggle={toggle}
			onOpened={fillCatalog}
			activeOp={activeOp}
			activeOpText={activeOpText}
			onImageChange={onImageChange}
			cardImageRef={cardImage}
			handleCancelClick={handleCancelModal}
			handleSaveClick={finishOperation}
			addNewcardLoading = {addNewcardLoading}
			formRef={form}
			token={token}
			maxAmtControl={maxAmtControl}
			setCurrencyId={setCurrencyId}
			currencyId={currencyId}
			cardImageInput={cardImageInput}
			setCardImageInput={setCardImageInput}
			setCurrencyName={setCurrencyName}
			currencyName={currencyName}
			/>
		<div className="content">
			<Row>

			
				<Col md="12">
					<Card>
						<CardHeader className="d-flex justify-content-between">
								<CardTitle tag="h4">Ncentiva Platform Gift Card Type List</CardTitle>
								<Col md="auto" className="align-content text-align-right">
								<Button
                              className="add_card btn btn-primaryTwo"
                              style={{ cursor: "pointer" }}
                              type="button"
                              onClick={() => toggleUpload()}
                            >
                              UPLOAD FILE
                            </Button>
									<MotionButton initial={{ x: "-500%", opacity: 0 }} 
									className="add_card btn btn-primaryTwo" animate={{ x: 0, opacity: 1, transition: { delay: 0.4, duration: 0.5 } }} 
									 onClick={prepareToAdd}>
										<i className="fas fa-history pr-2"/>Add new card type
									</MotionButton>
								</Col> 
						</CardHeader>
						<CardBody >
						<div className="data_table">
							<Datatable
							id="example"
								ref={setTable}
								options={{
									dom: 'tip',	
								}}
								columns={header}
								data={null}
								addRemoveButton={{callback: remove}}
								addEditButton={{callback: prepareToEdit}}
								enableSelectFilters={true}
							/>
							</div>
						</CardBody>
					</Card>
				</Col>
			</Row>
			<Modal
                    isOpen={upload}
                    toggle={toggleUpload}
                    backdrop="static"
                    centered={true}
                    size="xl"
                  >
                    <ModalHeader toggle={toggleUpload} className="custom_header_colourTwo">
                      {activeOp} Brand
                    </ModalHeader>
                    <Form>
                      <ModalBody>
                        <div className={modalCSVcss.container}>
                          <div className="text">
							<div className="tooltip-container" onMouseEnter={() => setShowTooltip(true)}
						onMouseLeave={() => setShowTooltip(false)} style={{ cursor: "pointer",marginLeft:"32px" }}>
							<p
						className="text-center tooltip-trigger mb-0"
																
						>
						<BsInfoCircle size={20}  />
						</p>
						{showTooltip && (
						<div className="tooltip-content">
						<p>
						You can download a template, add the Gift cards using the format, and delete the gift cards you don’t need to add. 
						</p>
						<p>Please select a file of type CSV and press Save.</p>
						</div>
						)}
						</div>
						<p className="text_format">Instructions</p>
						</div>
                          <label
                            htmlFor="file"
                            className={modalCSVcss.formContainer}
                          >
                            <UploadIcon />
                            <span>File Upload CSV</span>
                            <input
                              type="file"
                              name=""
                              id="file"
                              className={modalCSVcss.dn}
                              onChange={handleFileChange}
                              // ref={file}
                              accept=".csv"
                            />
                          </label>

                          {fileCsv?.name && (
                            <div className={modalCSVcss.fileSelected}>
                              <p>
                                {fileCsv.name}{" "}
                                <span className="arrow">
                                  <img src={okIMG} alt="" />
                                </span>
                              </p>
                            </div>
                          )}
                        </div>
                        <p
                          className="dbuttonc"
                          style={{
                            color: "#2665F2",
                            fontWeight: "900",
                            cursor: "pointer",
                            fontSize: "18px",
                          }}
                          
                          onClick={() => {
                            downloadBrandLimit();
                          }}
                        >
                          Download Template
                        </p>
                      </ModalBody>
                      <ModalFooter>
                        <Button
                          type="button"
                          color="secondary"
                          onClick={toggleUpload}
                        >
                          Cancel
                        </Button>{" "}
                        <Button
                          type="submit"
                          className="btn btn-primaryTwo"
                          onClick={handleFileUpload}
						  disabled={cardSave}
                        >
                      {!cardSave && "Save"}
					  {
						cardSave && <Spinner
						as="span"
						animation="border"
						size="sm"
						role="status"
						aria-hidden="true"
						style={{
							margin: "0px 8px"
						}}
					/>}
                        </Button>
                      </ModalFooter>
                    </Form>
                  </Modal>
			<Modal isOpen={confirmModal} toggle={toggleConfirm} backdrop="static">
				<ModalHeader className="custom_header_colourTwo" toggle={toggleConfirm}>Remove Card Type</ModalHeader>
				<ModalBody>
					<p className="card-just-text">
						Are you sure you want to remove the card type "{!!operativeRow && !!operativeRow.productName ? operativeRow?.productName : ""}"?
					</p>
				</ModalBody>
				<ModalFooter>
					<Button color="secondary" onClick={toggleConfirm}>Cancel</Button>{' '}
					<Button className="btn btn-primaryTwo" onClick={confirmRemoval}>Yes</Button>
				</ModalFooter>
			</Modal>
			<ModalHistorySKU modalHistory={modalHistory} toggleModalHistory={toggleModalHistory} token={token} />
			<Modal isOpen={warningModal} toggle={toggleWarning} backdrop="static">
            <ModalHeader className="custom_header_colourTwo" toggle={toggleWarning}>Access Denied</ModalHeader>
            <ModalBody>
                <p className="card-just-text">
				You do not have access to perform this action
                </p>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggleWarning}>Close</Button>
            </ModalFooter>
        </Modal>
		</div>
		
	
		</>);
}

export default React.memo(CardTypeView);
